import { atom } from "recoil";

export interface Upsell {
  uid: string;
  description: string;
  price: number; // Integer
}

const upsellsAtom = atom<Upsell[] | null>({
  key: "upsellsAtom",
  default: null,
});

export default upsellsAtom;
